// Import Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Import components
import PerformanceDetails from '../PerformanceDetails';

// Import utilities
import { getClassNames } from '../../../utils';

const BookTicketsModal = ({ handleClose, show, ...props }) => (
  <div
    className={getClassNames(props, 'c-modal  c-modal--ticket  c-modal--absolute', {
      'is-visible': show,
    })}
  >
    <div className="c-modal__inner">
      <button className="c-modal__close" type="button" onClick={handleClose}>
        <span className="u-visually-hidden">close</span>
      </button>

      <div className="c-modal__content">
        <PerformanceDetails {...props} />
      </div>
    </div>
  </div>
);

BookTicketsModal.propTypes = {
  handleClose: PropTypes.func,
  show: PropTypes.bool.isRequired,
};

BookTicketsModal.defaultProps = {
  handleClose: null,
};

export default BookTicketsModal;
